import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as uiTypes } from './types';
export { default as uiSelectors } from './selectors';
export { default as uiOperations } from './operations';

// Default export is the reducers
export default reducers;
